// plugins/cartSync.client.ts
import { watch } from "vue";
import { onNuxtReady } from "#app";
import { useAuthStore } from "~/stores/auth";
import { useCartStore } from "~/stores/cart";

export default defineNuxtPlugin(() => {
  // Стартуємо після NuxtReady, щоб інжекти (типу $db) вже були доступні
  onNuxtReady(() => {
    const auth = useAuthStore();
    const cart = useCartStore();

    let running = false;
    const run = async () => {
      if (running) return;
      running = true;
      try {
        await cart.onAuthChanged();
      } catch (e) {
        // onAuthChanged репортить сам; тут — щоб не було unhandled rejection
        console.warn("[cart-sync] plugin", e);
      } finally {
        running = false;
      }
    };

    watch(
      () => ({ ready: auth.ready, uid: (auth.user as any)?.uid || null }),
      async (st, prev) => {
        const prevReady = prev?.ready ?? false;
        const prevUid = prev?.uid || null;
        const uid = st.uid;

        // Коли auth стає ready після рефреша, user може вже бути встановлений,
        // але попередній виклик ми пропускали (ready=false) — тому треба синкнути тут.
        const becameReady = st.ready && !prevReady;

        const isLogin = !!st.ready && !prevUid && !!uid;
        const isLogout = !!st.ready && !!prevUid && !uid;
        const isUserSwitch =
          !!st.ready && !!prevUid && !!uid && prevUid !== uid;

        // - НЕ чіпаємо кошик при старті для гостя.
        // - При старті для авторизованого: becameReady + uid.
        if ((becameReady && !!uid) || isLogin || isLogout || isUserSwitch) {
          await run();
        }
      },
      { immediate: true },
    );
  });
});
